import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IPostItem {
  img: string;
  tag: string;
  date: string;
  title: string;
  link: string;
  description: string;
}
const PostItem = ({ img, tag, date, title, link, description }: IPostItem) => {
  return (
    <Container>
      <PostImage alt={title} src={img} />
      <Flex>
        <TagContainer>
          <Typography size="lg" weight="medium">
            {tag}
          </Typography>
        </TagContainer>
        <Typography weight="semibold" color={Colors.yellow400}>
          {date}
        </Typography>
      </Flex>
      <Flex>
        <Typography size="4xl" weight="semibold" color={Colors.white300}>
          {title}
        </Typography>
        <LinkIcon href={link} target="_blank">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M6 18L18 6M18 6H9M18 6V15"
              stroke="#F5F5F5"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </LinkIcon>
      </Flex>
      <Typography size="xl" color={Colors.grey500}>
        {description}
      </Typography>
    </Container>
  );
};

export default PostItem;

const Container = styled.div`
  width: 100%;
  border-radius: 0.8rem;
  border: 1px solid ${Colors.grey700};
  background-color: ${Colors.grey900};
  padding: 1.6rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const PostImage = styled.img`
  width: 100%;
  margin-bottom: 3.2rem;
  border-radius: 0.6rem;
  object-fit: cover;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.2rem;
`;

const TagContainer = styled.div`
  padding: 0.4rem 1rem;
  border-radius: 1.6rem;
  background-color: ${Colors.grey600};
`;

const LinkIcon = styled.a`
  cursor: pointer;
  width: 2.4rem;
`;
